import * as mapResultsActions from './map-results.actions';
import { mapResultsState, initialState, mapResultsReducersState } from './map-results.state';
import { ActionReducerMap } from '@ngrx/store';

export function reducer(
  state: mapResultsState = initialState,
  action: mapResultsActions.mapResultsAction
): mapResultsState {
  switch (action.type) {
    case mapResultsActions.SET_CARD_LIST: {
      return {
        cards: action.payload,
      };
    }

    case mapResultsActions.ADD_TO_CARD_LIST: {
      const cardList = [...action.payload, ...state.cards];
      const uniqueList = cardList.filter((element, index, array) => array.indexOf(element) === index);

      return {
        cards: uniqueList,
      };
    }

    case mapResultsActions.CLEAR_CARD_LIST: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}

export const mapResultsReducer: ActionReducerMap<mapResultsReducersState> = {
  data: reducer,
};
